import axios from '@/services/api'

/**
 *
 * @returns {Promise<Object>}
 */
export const getResources = (queryParams) => {
	const url = `/api/resources${queryParams}`
	return axios.get(url)
}

/**
 * @param {Number} categoryId
 *
 * @returns {Promise<Object>}
 */
export const getResource = (categoryId) => {
	const url = `/api/resources/${categoryId}`
	return axios.get(url)
}

export const getResourceAllTags = (query) => {
	const url = '/api/tags?filter=resources'
	return axios.get(url, { params: query })
}

export const getAllTypes = () => {
	const url = '/api/resources/resource-type'
	return axios.get(url)
}

export const getAllAuthor = (query) => {
	const url = '/api/resources?filter=author&fields=resource_id,resource_author'
	return axios.get(url, { params: query })
}
